import { useGetDatasetMetadata } from "@/api/dataset/useDatasetAPI";
import { SpatialAggregationType } from "@/types/common";
import { DatasetConfigAttributeResponse } from "@/types/project";

interface ConfigurationDatasetProps {
  dataset: {
    attributes: DatasetConfigAttributeResponse[];
    available: boolean;
    id: string;
    name: string;
    spatial_aggregation_type: SpatialAggregationType;
  };
}

export default function ConfigurationDataset({
  dataset
}: ConfigurationDatasetProps) {
  const { data } = useGetDatasetMetadata(dataset.id);

  const attributeDescriptions = dataset.attributes
    .map((attribute) => {
      const schema = data?.schema?.find((item) => item.id === attribute.id);

      if (schema?.attribute_code?.includes("adm_area_level")) {
        return null;
      }

      const criteria = attribute.filter?.criteria;
      return criteria ? criteria.split("|").join(", ") : null;
    })
    .filter((description): description is string => Boolean(description));

  return (
    <li>
      <b>{dataset.name}</b>
      {attributeDescriptions.length > 0 &&
        `: ${attributeDescriptions.join(", ")}`}
    </li>
  );
}
